import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Calendar, Heart, Building2, Star } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { openEnquiry } from './EnquiryModal';
import { Button } from './ui/button';

const ProjectCard = ({ project }) => {
  const { t, formatPrice, shortlist, toggleShortlist } = useApp();
  const saved = shortlist.includes(project.id);

  const statusBadge = project.status === 'comingsoon'
    ? t('coming_soon')
    : `${project.plan} ${t('payment_plan')}`;

  return (
    <div className="group bg-white rounded-xl overflow-hidden card-lift border border-gobra-sand flex flex-col">
      <Link to={`/project/${project.id}`} className="relative block overflow-hidden aspect-[4/3] bg-gobra-sand">
        {project.image && <img src={project.image} alt={project.name} loading="lazy"
          className="h-full w-full object-cover img-zoom" />}
        <div className="absolute top-3 left-3 flex flex-col items-start gap-2">
          {project.featured && (
            <span className="inline-flex items-center gap-1 bg-gobra-orange text-white text-[11px] font-semibold px-3 py-1.5 rounded-full shadow">
              <Star className="h-3 w-3 fill-white" /> Featured
            </span>
          )}
          <span className="bg-gobra-slate/90 backdrop-blur-sm text-white text-[11px] font-medium px-3 py-1.5 rounded-full">
            {statusBadge}
          </span>
        </div>
        <button onClick={(e) => { e.preventDefault(); toggleShortlist(project.id); }}
          aria-label="Shortlist"
          className="absolute top-3 right-3 h-9 w-9 rounded-full bg-white/90 flex items-center justify-center hover:bg-white transition-colors">
          <Heart className={`h-4 w-4 ${saved ? 'fill-gobra-terracotta text-gobra-terracotta' : 'text-gobra-slate'}`} />
        </button>
      </Link>

      <div className="p-4 md:p-5 flex flex-col flex-1">
        <Link to={`/project/${project.id}`}>
          <h3 className="font-title text-lg font-semibold text-gobra-slate hover:text-gobra-green transition-colors leading-snug">
            {project.name}
          </h3>
        </Link>
        <div className="mt-2 space-y-1.5 text-sm text-muted-foreground">
          <div className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5 text-gobra-terracotta" /> {project.area}</div>
          <div className="flex items-center gap-1.5"><Building2 className="h-3.5 w-3.5 text-gobra-terracotta" /> {project.developer}</div>
          <div className="flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5 text-gobra-terracotta" /> {t('handover_in')} {project.handover}</div>
        </div>

        <div className="mt-auto pt-4 flex items-end justify-between gap-2">
          <div>
            <div className="text-[11px] text-muted-foreground uppercase tracking-wide">{t('from')}</div>
            <div className="font-title text-xl font-bold text-gobra-green">{formatPrice(project.priceAed)}</div>
          </div>
          <Button onClick={() => openEnquiry(project.name)} size="sm"
            className="bg-gobra-green hover:bg-gobra-terracotta text-white rounded-full px-4">
            {t('enquire_now')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
